// src/beta/components/Slide.tsx
import type { V1Slide } from '@/beta/types/story';
import { ImageSlide } from '@/beta/components/slides/ImageSlide';
import { GallerySlide } from '@/beta/components/slides/GallerySlide';
import { TextSlide } from '@/beta/components/slides/TextSlide';
import { DocumentSlide } from '@/beta/components/slides/DocumentSlide';
import { ComparisonSlide } from '@/beta/components/slides/ComparisonSlide';
import { DividerSlide } from '@/beta/components/slides/DividerSlide';

interface Props { slide: V1Slide; }

/** Routes a V1Slide to the correct variant based on slide.type.
 *  Falls back to TextSlide for unknown types so the deck never blanks. */
export function Slide({ slide }: Props) {
  switch (slide.type) {
    case 'image':       return <ImageSlide slide={slide} />;
    case 'gallery':     return <GallerySlide slide={slide} />;
    case 'comparison':  return <ComparisonSlide slide={slide} />;
    case 'divider':     return <DividerSlide slide={slide} />;
    case 'document':    return <DocumentSlide slide={slide} />;
    case 'text':
    case 'orphan-text': return <TextSlide slide={slide} />;
    default:            return <TextSlide slide={slide} />;
  }
}
